import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

import { PortalThemeService } from '../services/portal-theme.service';

export const portalThemeResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot) => {
  const portalId = route.data['portal'] as string | undefined;
  if (portalId) {
    inject(PortalThemeService).setPortal(portalId);
  }
};
